export function getReferenceFieldName(obj = {}, modelName) {
    // DK: Special case for categories
    if (modelName === "Category") {
        return "id";
    }
    return ["name", "title", "username"].find((value) => Object.keys(obj).includes(value)) || "id";
}
